'use strict';
angular.module('controllers')
	.directive('cropImage', ['$compile', '$parse', '$timeout', function($compile, $parse, $timeout) {

		var directive = {};
		directive.restrict = 'E';
		//directive.scope = false;
		//directive.transclude = false;
		directive.link = function (scope, elem, attrs) {

			var data;scope.state = {};
			scope.image = '';

			scope.imageSize = '';
			scope.imageType = '';

			scope.cropper = {};
			scope.cropperProxy = 'cropper.first';

			var imageModel = angular.element(elem[0].querySelector('#fileImage'));
			var model = imageModel.attr('ng-model');
			var scopeModel = imageModel.scope();
			var imgModel = model.split('.')[1];

			scope.$watch('modelData', function (newValue, oldValue) {
				if (!angular.isUndefined(attrs.multiple)) {
					scope.dataUrl = false;
					scopeModel.modelData.images = {};
					scope.count = 0;
				} else {
					if (!angular.isUndefined(scopeModel.modelData[imgModel]) && scopeModel.modelData[imgModel] != '' && scopeModel.modelData[imgModel] !== null) {
						var ext = scopeModel.modelData[imgModel].split('.')[1];
						scopeModel.modelData.imageType = 'image/' + ext;

						scope.dataUrl = scope.additionals['publicPath'] + '/' + scopeModel.modelData[imgModel];
						var image = angular.element(elem[0].querySelector('#image')).attr('src', scope.dataUrl);
						scope.image = scope.additionals['publicPath'] + '/' + scopeModel.modelData[imgModel];
						hideCropper();
						$timeout(showCropper);

					} else {
						scope.dataUrl = false;
						scope.image = '';
						angular.element(elem[0].querySelector('#image')).attr("src", '');
					}
				}
			});

			elem[0].addEventListener(
				'click',
				function (event) {
					scope.preview();
					return false;
				},
				false
			);

			//scope.count = 0;
			scope.cropedImage = [];
			scope.onFile = function(files) {
				var file = files[0];
				var reader = new FileReader();
				reader.onload = function (ev) {
					 scope.$apply(function($scope){

						scope.image = ev.target.result;
						scope.count++;
						scope.dataUrl = ev.target.result;

						hideCropper();
						$timeout(showCropper);

						if(!angular.isUndefined(attrs.multiple)) {
								angular.element(elem[0].querySelector('#image-' + scope.count)).attr("src", ev.target.result);
						} else {
								angular.element(elem[0].querySelector('#image')).attr("src", ev.target.result);
						}
						angular.element(elem[0].querySelector('#close-' + scope.count)).css('display', 'block');

						if(!angular.isUndefined(attrs.multiple)) {
							$scope.cropedImage[scope.count] = ev.target.result;
							/* for editing multiple models */

							scopeModel.modelData.images[scope.count] = ev.target.result;
							//scopeModel.modelData.multipleImages = ev.target.result;
							//scopeModel.modelData.multipleImageType = file.type;
							//scopeModel.modelData.multipleImageSize = (file.size/1024).toFixed(2);
							/* end for editing multiple models */
						}else{
							$scope.cropedImage = ev.target.result;
							scopeModel.modelData.image = ev.target.result;
							scopeModel.modelData.imageType = file.type;
							scopeModel.modelData.imageSize = (file.size/1024).toFixed(2);
						}

						angular.element(elem[0].querySelector('#img')).css('display', 'block');
						$timeout(function () {
								scope.preview();
						}, 500);

					});
				};
				reader.readAsDataURL(file);

			};

			scope.preview = function() {
				if(scope.dataUrl !== false) {
					if (!angular.isUndefined(attrs.multiple)) {
						var image = angular.element(elem[0].querySelector('#image-' + scope.count)).attr("src", scope.image);
					} else {
						var image = angular.element(elem[0].querySelector('#image')).attr("src", scope.image);
					}

					if (!data) {
						data = {x: 0, y: 0, width: 100, height: 100, rotate: 0};
					}
					if (!angular.isUndefined(image[0])) {
						if (!angular.isUndefined(scope.count) && !isNaN(scope.count)) {
							var canvas = createCanvas(data, scope.count);
						} else {
							var canvas = createCanvas(data, 0);
						}
						var context = canvas.getContext('2d');
						context.drawImage(image[0], data.x, data.y, data.width, data.height, 0, 0, data.width, data.height);

						var array = scope.image.split(',');
						if (array[0].match(/:(.*?);/) == null) {
							var arrayExistingImage = scope.image.split('.');
							var mimeType = arrayExistingImage[1];
						} else {
							var mimeType = array[0].match(/:(.*?);/)[1];
						}
						var encoded = canvas.toDataURL(mimeType);
						removeElement(canvas);

						if (!angular.isUndefined(attrs.multiple)) {
							scope.cropedImage[scope.count] = encoded;
							/* for editing multiple models */
							scopeModel.modelData.images[scope.count] = encoded;
							//scopeModel.modelData.multipleImages = encoded;
						} else {
							scope.cropedImage = encoded;
							scopeModel.modelData.image = encoded;
						}

						// scope.data = {};
						// scope.data.width = Math.round(data.width);
						// scope.data.height = Math.round(data.height);
						if (!angular.isUndefined(attrs.multiple)) {
							angular.element(elem[0].querySelector('#image-' + scope.count)).attr("src", encoded);
						} else {
							angular.element(elem[0].querySelector('#image')).attr("src", encoded);
						}
					}
				}
			}

			scope.deleteFile = function(ev, key) {
				//ev.preventDefault();
				//ev.stopPropagation();
				angular.element(elem[0].querySelector('#image-' + key)).attr("src", '');
				//angular.element(elem[0].querySelector('#close-' + key)).css('display', 'none');
				if (!angular.isUndefined(scope.data)) {
					if (!angular.isUndefined(scope.data[key])) {
						scope.data[key].width = false;
						scope.data[key].height = false;
					}
				}
				if (!angular.isUndefined(attrs.multiple)) {
	        //scopeModel.modelData.images.splice(key, 1);
					delete scopeModel.modelData.images[key];
				} else {
	        scope.dataUrl = false;
	        scope.image = '';
				}
				scope.$applyAsync();
			}

			function createCanvas(data, index) {
				var canvas = document.createElement('canvas');
				canvas.width = data.width;
				canvas.height = data.height;
				canvas.style.display = 'none';
				document.body.appendChild(canvas);

				if (angular.isUndefined(scope.data)) {
					scope.data = {};
				}
				scope.data[index] = {};
				scope.data[index].width = Math.round(data.width);
				scope.data[index].height = Math.round(data.height);
				scope.$applyAsync();

				return canvas;
			}

			function removeElement(el) {
				el.parentElement.removeChild(el);
			}

			scope.options = {
				maximize: true,
				aspectRatio: 'free',
				rotatable: true,
				movable: true,
				autoCrop:true,
				crop: function(dataNew) {
					data = dataNew;
				}
			};

			scope.showEvent = 'show';
			scope.hideEvent = 'hide';

			function showCropper() { scope.$broadcast(scope.showEvent); }
			function hideCropper() { scope.$broadcast(scope.hideEvent); }

		}
	return directive;
}]);
